export const systemSettingsMenuItems = {
  SYSTEM_HEALTH: 'health',
  FRANCHISES: 'franchises',
  CAMPAIGN_ORGANIZERS: 'campaign-organizers',
  EVENT_ORGANIZERS: 'event-organizers',
  ACCESS_KEYS: 'access-keys',
  AUDIT_TRAIL: 'audit-trail',
  URL_UNLOCKING: 'url-unlocking',
  DISABLE_ORGANIZATION: 'disable-organization',
  BULK_CHARGE_GUARANTEE: 'bulk-charge-guarantee',
  ADD_ORGANIZATION_TO_EVENTS: 'add-organization-to-events',
  CONSENT_DOCUMENT_VERSIONS: 'consent-document-versions',
  GIFT_MATCHING_POOLS: 'gift-matching-pools'
};

export const systemSettingsRoutes = {
  BASE: '/system-settings',
  HEALTH: '/system-settings/health',
  FRANCHISES: '/system-settings/franchises',
  FRANCHISES_CREATE: '/system-settings/franchises/create',
  FRANCHISES_EDIT: '/system-settings/franchises/edit', // append /:id
  CAMPAIGN_ORGANIZERS: '/system-settings/campaign-organizers',
  CAMPAIGN_ORGANIZERS_CREATE: '/system-settings/campaign-organizers/create',
  CAMPAIGN_ORGANIZERS_EDIT: '/system-settings/campaign-organizers/edit', // append /:id
  EVENT_ORGANIZERS: '/system-settings/event-organizers',
  EVENT_ORGANIZERS_CREATE: '/system-settings/event-organizers/create',
  EVENT_ORGANIZERS_EDIT: '/system-settings/event-organizers/edit', // append /:id
  ACCESS_KEYS: '/system-settings/access-keys',
  ACCESS_KEYS_CREATE: '/system-settings/access-keys/create',
  AUDIT_TRAIL: '/system-settings/audit-trail',
  URL_UNLOCKING: '/system-settings/url-unlocking',
  DISABLE_ORGANIZATION: '/system-settings/disable-organization',
  BULK_CHARGE_GUARANTEE: '/system-settings/bulk-charge-guarantee',
  ADD_ORGANIZATION_TO_EVENTS: '/system-settings/add-organization-to-events',
  CONSENT_DOCUMENT_VERSIONS: '/system-settings/consent-document-versions',
  GIFT_MATCHING_POOLS: '/system-settings/gift-matching-pools',
  GIFT_MATCHING_POOLS_CREATE: '/system-settings/gift-matching-pools/create',
  GIFT_MATCHING_POOLS_EDIT: '/system-settings/gift-matching-pools/edit' // append /:id
};

export const i18nKeys = {
  TITLE: 'systemSettings.title',
  MENU: {
    SYSTEM_HEALTH: 'systemSettings.menu.systemHealth',
    FRANCHISES: 'systemSettings.menu.franchises',
    CAMPAIGN_ORGANIZERS: 'systemSettings.menu.campaignOrganizers',
    EVENT_ORGANIZERS: 'systemSettings.menu.eventOrganizers',
    ACCESS_KEYS: 'systemSettings.menu.accessKeys',
    AUDIT_TRAIL: 'systemSettings.menu.auditTrail',
    URL_UNLOCKING: 'systemSettings.menu.urlUnlocking',
    DISABLE_ORGANIZATION: 'systemSettings.menu.disableOrganization',
    BULK_CHARGE_GUARANTEE: 'systemSettings.menu.bulkChargeGuarantee',
    ADD_ORGANIZATION_TO_EVENTS: 'systemSettings.menu.addOrganizationToEvents',
    CONSENT_DOCUMENT_VERSIONS: 'systemSettings.menu.consentDocumentVersions',
    GIFT_MATCHING_POOLS: 'systemSettings.menu.giftMatchingPools'
  },
  COMING_SOON: 'systemSettings.comingSoon'
};
